import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { PriceComponent } from './price.component';
import { InputDebounceComponent } from './input-debounce.component';
import { DateComponent } from './date.component';
import { DialogComponent } from './dialog.component';
import { AvatarComponent } from './avatar.component';

import { ModalModule } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GrowlModule } from 'primeng/primeng';
import { ImageFbComponent } from './imageFb.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    GrowlModule,
    BrowserModule,
    HttpClientModule,
  ],
  declarations: [
    PriceComponent,
    DateComponent,
    DialogComponent,
    AvatarComponent,
    InputDebounceComponent,
    ImageFbComponent,
  ],
  exports: [PriceComponent, DateComponent, DialogComponent, AvatarComponent, InputDebounceComponent, ImageFbComponent],
  providers: [],
})
export class HelperModule {}



// WEBPACK FOOTER //
// ./src/app/common/helper/helper.module.ts